import { DriverPayType } from '@app/core/model/driver-paytype.model';
import { DriverSalary } from '@app/core/model/payment.model';
import { IPaymentService } from '@app/core/services/interface/IPaymentService';

export class MockPaymentnService implements IPaymentService {
  constructor() {}

  getDriverPayType(driverCode: string): Promise<DriverPayType> {
    const promise = new Promise<DriverPayType>((resolve, reject) => {
      resolve({ payType: 'TSM', amount: 0.07 });
    });
    return promise;
  }
}
